<template>
  <div>
    <div class="content-message" v-if="isCookie"> 
				<div class="content-message-cont">
					<div class="content-message-cont-text">
						{{ $t('cookie.text') }}
					</div>
					<div class="content-message-cont-btn">
						<div class="content-message-cont-btn-leftBtn">
							<div @click="manageCookies">
								<strong>{{ $t('cookie.leftBtn') }}</strong>
							</div>
						</div>
						<div class="content-message-cont-btn-rightBtn">
							<div @click="onlyCookies">
								<strong>{{ $t('cookie.rightBtnLeft') }}</strong>
							</div>
							<div @click="allCookies">
								<strong>{{ $t('cookie.rightBtnRight') }}</strong>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog
				:visible.sync="isCookieChild"
				width="50%"
				center
				custom-class="cookie-dialog"
				:before-close="handleClose"
				:close-on-click-modal="true"
				:close-on-press-escape="true"
			>
				<div class="cookie-dialog-title">
					<strong>{{ $t('cookie.child.title') }}</strong>
				</div>
				<div class="cookie-dialog-content">{{ $t('cookie.child.text') }}</div>
				<div class="cookie-dialog-btnTopParent">
					<div class="cookie-dialog-btnTop">{{ $t('cookie.child.btnTop') }}</div>
				</div>
				<div class="cookie-dialog-bottom">
					<div class="cookie-dialog-bottom-title">
						<strong>
							{{ $t('cookie.child.textBottomTitle') }}
						</strong>
					</div>
					<div class="cookie-dialog-bottom-content">
						<div class="cookie-dialog-bottom-content-item" v-for="(group, i) in groups" :key="i">
              <button class="cookie-dialog-bottom-content-head" @click="toggle(i)" :aria-expanded="openIndex === i">
                  <!-- <span class="cookie-dialog-bottom-content-icon" :class="{ open: openIndex === i }">+</span> -->
									<span class="cookie-dialog-bottom-content-icon">
										<i class="el-icon-plus" v-if="openIndex !== i"></i>
										<i class="el-icon-minus" v-else></i>
									</span>
                  <span class="cookie-dialog-bottom-content-name">{{ group.name }}</span>
                  <span class="cookie-dialog-bottom-content-spacer"></span>
                  <label class="cookie-dialog-bottom-content-switch">
                    <el-switch
											v-if="i !== 0"
											v-model="group.switchValue"
											active-color="#64715d"
											inactive-color="#d9d9d9">
										</el-switch>
                  </label>
              </button>
              <div class="cookie-dialog-bottom-content-body" v-show="openIndex === i">
                  <p v-for="(p, idx) in group.paragraphs" :key="idx">{{ p }}</p>
              </div>
            </div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="closeCookies">{{ $t('cookie.child.btnBottom') }}</el-button>
				</span>
			</el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Cookies',
  data() {
    return {
      isCookie: true, //是否显示cookie
			isCookieChild: false,
			dialogVisible: false,
			openIndex: 0,
			groups: [
        {
            name: this.$t('cookie.child.groupsList.group1.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group1.paragraphs'),
                this.$t('cookie.child.groupsList.group1.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group2.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group2.paragraphs'),
                this.$t('cookie.child.groupsList.group2.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group3.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group3.paragraphs'),
                this.$t('cookie.child.groupsList.group3.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group4.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group4.paragraphs')
						],
						switchValue:false,
        }
      ]
    }
  },
  methods: {
		manageCookies () {
			this.isCookieChild = true;
		},
		closeCookies () {
			this.isCookieChild = false;
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
      this.isCookie = false;
		},
		onlyCookies () {
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
      this.isCookie = false;
		},
		allCookies () {
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
			this.isCookie = false;
		},
		handleClose (done) {
			this.isCookieChild = false;
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
		},
		toggle(idx) {
        this.openIndex = this.openIndex === idx ? -1 : idx;
    },
    save() {
        alert('已保存Cookie偏好设置');
    },
    enableAll() {
        this.groups = this.groups.map(g => ({ ...g, enabled: true }));
    }
  }
}

</script>
<style scoped>
.content-message{
	width: 60%;
	height: 10vw;
	position: fixed;
	right: 0;
	bottom: 2%;
	z-index: 999;
	padding: 1.5%;
	background-color: #ffffff;
	box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
	border-radius: 30px;
}
.content-message-cont{
	width: 100%;
	height: 100%;
	display: flex;
  flex-direction: column;
	gap: 1vw;
}
.content-message-cont-text{
	font-size: 1vw;
	color: #252323;
}
.content-message-cont-btn{
	height: 3vw;
	display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-message-cont-btn-leftBtn{
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.content-message-cont-btn-leftBtn strong{
	font-size: 1vw;
	color: #1E1E1E;
}
.content-message-cont-btn-leftBtn div{
	border-radius: 10px;
  border: 3px solid #1E1E1E;
  padding: 0.5vw;
	cursor: pointer;
}
.content-message-cont-btn-leftBtn div:hover{
	background-color: #1E1E1E;
}
.content-message-cont-btn-leftBtn div:hover strong{
	color: #fff;
}
.content-message-cont-btn-rightBtn{
	padding-right:2%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 2%;
	width: 50%;
}
.content-message-cont-btn-rightBtn strong{
	font-size: 1vw;
}
.content-message-cont-btn-rightBtn div:nth-child(1){
	border-radius: 10px;
  border: 3px solid #1E1E1E;
  padding: 0.5vw;
	cursor: pointer;
}
.content-message-cont-btn-rightBtn div:nth-child(1):hover{
	background-color: #1E1E1E;
}
.content-message-cont-btn-rightBtn div:nth-child(1):hover strong{
	color: #fff;
}
.content-message-cont-btn-rightBtn div:nth-child(2){
	border-radius: 10px;
  border: 3px solid #1E1E1E;
  padding: 0.5vw;
	cursor: pointer;
	background-color: #1E1E1E;
	color: #fff;
}
.content-message-cont-btn-rightBtn div:nth-child(2):hover{
	background-color: transparent;
}
.content-message-cont-btn-rightBtn div:nth-child(2):hover strong{
	color: #1e1e1e;
}
/* cookie弹框按钮操作后样式 */
.cookie-dialog{
	border-radius: 30px!important;
}
:deep(.el-dialog__headerbtn .el-dialog__close){
	font-size: 1vw;
  color: #1e1e1e!important;
}
:deep(.el-dialog__body){
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}
:deep(.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close){
	color: #1e1e1e!important;
}

:deep(.el-dialog__footer){
	text-align: right!important;
}
:deep(.el-button--primary){
  background-color: #1e1e1e;
  border-color: #1e1e1e;
  padding: 1% 3%;
  font-size: 0.8vw;
  border-radius: 10px;
}
:deep(.el-button--primary:focus),:deep(.el-button--primary:hover) {
  background: #1e1e1e!important;
  border-color: #1e1e1e!important;
}

.cookie-dialog-title{
	font-size: 1.2vw;
	color: #1e1e1e;
}

.cookie-dialog-content{
	font-size: 0.8vw;
	color: #959595;
}
.cookie-dialog-btnTopParent{
}
.cookie-dialog-btnTop{
	background-color: #1e1e1e;
  border-color: #1e1e1e;
  padding: 1% 3%;
  font-size: 0.8vw;
  border-radius: 10px;
  color: #fff;
  width: 20%;
	cursor: pointer;
	display: flex;
  justify-content: center;
  align-items: center;
}
.cookie-dialog-bottom{

}
.cookie-dialog-bottom-title{
	font-size: 1.2vw;
	color: #1e1e1e;
  margin-bottom: 1%;
}

/* .content-message-next{
	width: 60%;
	height: 10vw;
	position: fixed;
	right: 0;
	bottom: 2%;
	z-index: 999;
	padding: 1.5%;
	background-color: #ffffff;
	box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
	border-radius: 30px;	
}
.content-message-next-cont{
	width: 100%;
	height: 100%;
	display: flex;
  flex-direction: column;
	gap: 1vw;
} */
.cookie-dialog-bottom-content-item {
  border: 2px solid #979797;
  overflow: hidden;
}
.cookie-dialog-bottom-content-item:nth-child(1),.cookie-dialog-bottom-content-item:nth-child(2),.cookie-dialog-bottom-content-item:nth-child(3){
	border-bottom: none;
}
.cookie-dialog-bottom-content-item:nth-child(1){
	border-radius: 8px 8px 0px 0px;
}
.cookie-dialog-bottom-content-item:nth-child(4){
	border-radius: 0px 0px 8px 8px;
}

.cookie-dialog-bottom-content-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  padding: 10px;
  cursor: pointer;
}

.cookie-dialog-bottom-content-icon {
  border-radius: 4px;
  display: inline-grid;
  place-items: center;
  color: #2f3b34;
  font-size: 0.8vw;
}

.cookie-dialog-bottom-content-icon.open {
  transform: rotate(45deg);
}

.cookie-dialog-bottom-content-name {
  font-weight: 700;
  color: #29352d;
}

.cookie-dialog-bottom-content-spacer {
  flex: 1;
}
.cookie-dialog-bottom-content-switch{

}

.cookie-dialog-bottom-content-chip {
  background: #e9f3e8;
  color: #2f3b34;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.cookie-dialog-bottom-content-body {
  background: #fff;
  padding: 10px;
  color: #3a463f;
  line-height: 1.6;
}

.cookie-dialog-bottom-content-body p {
  margin: 0 0 8px;
}
</style>